import React from 'react';
import { roles } from '@nxsys/store/constants';

const PayrollOverviewList = React.lazy(
  () => import('../../../modules/payrollOverview/listing'),
);
const PayrollOverviewDetail = React.lazy(
  () => import('../../../modules/payrollOverview/detail'),
);
const PayrollOverviewEmployeeDetail = React.lazy(
  () => import('../../../modules/payrollOverview/employeeDetail'),
);

export const payrollOverviewConfig = [
  {
    permittedRole: [roles.employer],
    path: '/payroll',
    element: <PayrollOverviewList />,
  },
  {
    permittedRole: [roles.employer],
    path: '/payroll/:companyId',
    element: <PayrollOverviewDetail />,
  },
  {
    permittedRole: [roles.employer],
    path: '/payroll/:companyId/employee/:draftPayrollId',
    element: <PayrollOverviewEmployeeDetail />,
  },
];
